
import { Link } from 'react-router-dom';

export default function Process() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="process" className="py-16 sm:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center">
        <div className="mb-8 sm:mb-12">
          <div className="relative h-48 sm:h-72 lg:h-96 rounded-3xl overflow-hidden mx-auto">
            <img
              src="https://public.readdy.ai/ai/img_res/9d5b33409af27a9562dd6bea6b9c4df5.jpg"
              alt="Consultation process"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent"></div>
          </div>
        </div>

        <div className="space-y-6 mb-8 sm:mb-12">
          <p className="text-xl sm:text-2xl lg:text-4xl leading-relaxed">
            <span className="text-gray-500 font-light italic">Your journey begins with a </span>
            <span className="text-gray-400 font-light italic">simple conversation</span>
            <span className="text-gray-500 font-light">. We handle the </span>
            <span className="text-slate-900 font-bold">complexity</span>
            <span className="text-gray-500 font-light">, you focus on your </span>
            <span className="text-slate-900 font-bold">dreams</span>
            <span className="text-gray-500 font-light">.</span>
          </p>
        </div>

        <Link
          to="/booking"
          className="px-8 sm:px-12 py-4 bg-slate-900 text-white font-medium rounded-full hover:bg-slate-800 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-block text-sm sm:text-base"
        >
          Book Free Consultation
        </Link>

        <div className="mt-12 sm:mt-20 grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
          {[
            {
              step: '01',
              title: 'Initial Consultation',
              description: 'We understand your goals, budget, and preferences',
              icon: 'ri-chat-3-line'
            },
            {
              step: '02',
              title: 'University Selection',
              description: 'Personalized recommendations based on your profile',
              icon: 'ri-building-line'
            },
            {
              step: '03',
              title: 'Application & Visa',
              description: 'Complete support with documents and submissions',
              icon: 'ri-file-list-3-line'
            },
            {
              step: '04',
              title: 'Pre-Departure',
              description: 'Orientation and preparation for your new journey',
              icon: 'ri-flight-takeoff-line'
            }
          ].map((item, index) => (
            <div key={index} className="text-center space-y-3 sm:space-y-4">
              <div className="w-12 h-12 sm:w-16 sm:h-16 mx-auto bg-emerald-100 rounded-2xl flex items-center justify-center">
                <i className={`${item.icon} text-2xl sm:text-3xl text-emerald-600`}></i>
              </div>
              <div className="text-emerald-500 font-bold text-xs sm:text-sm">{item.step}</div>
              <h4 className="text-sm sm:text-lg font-bold text-slate-900">{item.title}</h4>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
